<dashboardnav>
  <cradua-quantum [quantums]="quantums$ | async" (quantum)="onSubmitQuantum($event)"
    (deleteQuantumEvent)="onDeleteQuantum($event)" *ngIf="(isLoadingQuantum$ | async ) === false">
  </cradua-quantum>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingQuantum$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
